/* global ReactSpringserveComponent */

angular.module('vastdesk').component('aiAgentChatDrawer', {
  template: require('../templates/aiAgentChatDrawer.html'),
  bindings: {
    linkId: '@',
    title: '@',
    agentId: '@',
    aiGatewayBaseUrl: '@',
    authToken: '@',
    contextId: '@',
  },
  controllerAs: '$aiAgentChatDrawerCtrl',
  controller: [
    '$scope',
    function ($scope) {
      const self = this;

      this.rootId = `component-root-angular-AgentChatDrawer-${crypto.randomUUID()}`;

      this.open = false;
      this.unregisterWatcher = null;

      this.handleClose = () => {
        self.open = false;
        $scope.$apply();
      };

      this.openDrawer = () => {
        self.open = true;
        $scope.$apply();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: 'AgentChatDrawer',
            rootId: self.rootId,
            componentProps: {
              title: self.title,
              open: self.open,
              onClose: self.handleClose,
              agentId: self.agentId,
              aiGatewayBaseUrl: self.aiGatewayBaseUrl || '',
              authToken: self.authToken || '',
              contextId: self.contextId || '',
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watch(
            '$aiAgentChatDrawerCtrl.open',
            () => {
              self.renderReactComponent();
            }
          );
        });

        // Listen for clicks on the AI Help Desk or AI Assistant links
        $(document).on('click', self.linkId, function (e) {
          e.preventDefault();
          self.openDrawer();
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
        $(document).off('click', self.linkId);
      };
    },
  ],
});
